import { NavLink } from 'react-router-dom';
import { NAV_BUTTON_BASE, NAV_BUTTON_ACTIVE } from './Header/navButtonStyles';

const ActiveLink = ({ to, children }) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive ? `${NAV_BUTTON_BASE} ${NAV_BUTTON_ACTIVE}` : NAV_BUTTON_BASE
      }
    >
      {children}
    </NavLink>
  );
};

export default ActiveLink;
